module.exports = __webpack_public_path__ + "static/media/Maggie.8ae3a972.jpg";